import { useTranslation } from 'react-i18next';

import cls from './google-recaptcha-notice.module.css';

export function GoogleRecaptchaNotice() {
    const { t } = useTranslation('translation');

    return (
        <div className={cls.notice}>
            {t('googleRecaptchaNotice.title')}{' '}
            <a
                className={cls.link}
                href="https://policies.google.com/privacy"
                rel="noopener noreferrer"
                target="_blank"
            >
                {t('googleRecaptchaNotice.link')}
            </a>{' '}
            {t('googleRecaptchaNotice.and')}{' '}
            <a
                className={cls.link}
                href="https://policies.google.com/terms"
                rel="noopener noreferrer"
                target="_blank"
            >
                {t('googleRecaptchaNotice.terms')}
            </a>{' '}
            {t('googleRecaptchaNotice.apply')}
        </div>
    );
}

GoogleRecaptchaNotice.displayName = 'GoogleRecaptchaNotice';
